import keyMirror from 'keymirror'

export const tenderRouteNames = keyMirror({
  tenders: null,
  tenderDetails: null,
  tenderDetailsView: null,
  tenderAddendumDetailsView: null,
  tenderAddendumDetails: null,
  tenderComparison: null,
  tenderSummary: null,
  analysisRecos: null,
  healthCheck: null,
  addendumSummary: null,
  queryStatus: null,
  tmView: null,
  'general-docs': null,
  threshold: null,
  tenderBidView: null, // vendor's Bid page
})

export const projectRouteNames = keyMirror({
  projects: null,
  projectDetail: null,
  vendorProjectDetail: null,
})

export const performanceRouteNames = keyMirror({
  performance: null,
  performanceRatingHistory: null,
})

export const dashboardRouterNames = keyMirror({
  publicLogin: null,
  login: null,
})

export const ccdRouteNames = keyMirror({
  contacts: null,
  companyView: null,
  companyEdit: null,
  companyCreate: null,
  ccdContactView: null,
  ccdContactEdit: null,
  ccdContactCreate: null,
  ccdTenancyView: null,
  ccdTenancyEdit: null,
  ccdTenancyCreate: null,
  tenantContacts: null,
  tenantCcdContactView: null,
  tenantCcdContactEdit: null,
  tenantCcdContactCreate: null,
  ccdTenancyTenantView: null,
  vendorContacts: null,
  vendorCcdContactView: null,
  vendorCcdContactCreate: null,
  vendorCcdContactEdit: null,
})

export const eCircularRouteNames = keyMirror({
  /* Engineer routes */
  ccdTenancyECirculars: null,
  eCircularHistory: null,
  createECircular: null,
  eCircularDetail: null,
  addRecipients: null,
  eCircularHistorySummary: null,
  /* Tenant Routes */
  tenantTenancyECirculars: null,
})

export const standaloneWpRouteNames = keyMirror({
  vendorStandaloneWp: null,
  tenantStandaloneWp: null,
  engineerStandaloneWp: null,
})

export const directoryRouteNames = keyMirror({
  /* Engineer routes */
  directories: null,
  directoryDetail: null,
  directoryDetailView: null,
  directoryOrder: null,
  directoryArchived: null,
  tenancyDirectories: null,
  /* Tenant Routes */
  tenantDirectories: null,
  tenantDirectoryDetail: null,
  tenantDirectoryDetailView: null,
})

export const workPermitRouteNames = keyMirror({
  allWorkPermits: null,
  hoistingAtLocation: null,
  createWorkPermit: null,
  vendorCreateWorkPermit: null,
})

export const tenancyRecordsRouteNames = keyMirror({
  /* Engineer routes */
  allTenancyRecs: null,
  ccdTenancyView: null,
  ccdTenancyCreate: null,
  ccdTenancyEdit: null,
  /* Tenant Routes */
  tenantAllTenancyRecs: null,
  ccdTenancyTenantView: null,
})

export const tenantProjectRouteNames = keyMirror({
  /* Engineer routes */
  handover: null,
  editTenantProject: null,
  tenantProject: null,
  allTenantProjects: null,
  /* Tenant Routes */
  tenantHandover: null,
  tenantProjectDetail: null,
  createTenantProject: null,
})

export const ExportContactsRouteNames = keyMirror({
  exportContacts: null,
  exportEmergency: null,
  exportMarketing: null,
  exportWorker: null,
  exportWorkPermits: null,
  exportFireMarshal: null,
})

export const ROUTER_PATHS = {
  DEPARTMENT: 'department',
  DEPARTMENT_PROFILE: 'department-profile',
  BUILDING_PROFILE: 'building-list-detail',
  SITE_PROFILE: 'site-profile',
  SETTING_USERS: 'setting-users',
  SITES: 'sites',
  LOCATION_LIST: 'location-list',
  LOCATION_DETAIL: 'location-detail',
  BUILDING_LIST: 'building-list',
  BUILDING_TEMPLATE: 'building-template',
  SECURITY_GROUP: 'security-group',
  SECURITY_GROUP_DETAIL: 'security-group-detail',
  ALL_CONTRACTORS: 'all-contractors',
  VENDOR_DETAIL: 'vendor-detail',
  ALL_TENANTS: 'all-tenants',
  TENANT_DETAIL: 'tenant-detail',
  TENANCY_USER_DETAIL: 'tenancy-user-detail',
  HKL_USER_DETAIL: 'hkl-user-detail',
  UPLOADED_FILE_SETTINGS: 'uploaded-file-settings',
  GENERAL_DOCS: 'general-docs',
  AUDIT_LOG: 'audit-log',
  TENANT_SIGNATURE_TEMPLATE: 'tenant-signature-template',
  VENDOR_SIGNATURE_TEMPLATE: 'vendor-signature-template',
  GUIDELINE: 'guideline',
  AUDIT_REPORT: 'audit-report',
  USER_GUIDE_FORMS_MANAGE: 'user-guide-forms-manage',
  REGION_CONFIG: 'region-config',
  SYSTEM_MAPPING_LIST: 'system-mapping',
}
